export const StarterItems = [
  {
    title: 'Soup of the Day',
    text: 'Different soup every day',
    price: '2,50',
    img: 'https://images.pexels.com/photos/1277483/pexels-photo-1277483.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Fries',
    text: 'Low-fat french fries',
    price: '2,25',
    img: 'https://images.pexels.com/photos/1583884/pexels-photo-1583884.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'American Salad',
    text: 'Daily salad made from fresh vegetables',
    price: '1,75',
    img: 'https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Pasta',
    text: 'Handmade pasta with our special sauce',
    price: '2,75',
    img: 'https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
];
